import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const heroContent = {
  eyebrow: 'PARA VOS, PROFESIONAL DE ESTIMULACIÓN TEMPRANA',
  headline: 'Acompañá el neurodesarrollo infantil con materiales clínicos listos para usar',
  subheadline: 'Organizá tus sesiones, evaluá con precisión e intervení con más claridad. Todo el material clínico que necesitás para acompañar el desarrollo de cada niño, listo para imprimir y aplicar.',
  rating: 5,
  ratingText: '4.9/5 (+850 reseñas verificadas)',
  ctaText: 'QUIERO EL PACK AHORA',
  // 👉 URL DE COMPRA
  ctaLink: 'https://habitandomicuerpo.shop/products/megapack-estimulacion-temprana-%E2%9C%A8',
  // 👉 IMAGEN PRINCIPAL DEL PRODUCTO
  imageUrl: 'https://cdn.magicpatterns.com/uploads/vkEvp98kQgD41XTeHK5mpz/ChatGPT_Image_14_may_2026,_21_20_34.png',
  imageAlt: 'MegaPack de Estimulación Temprana - 6 tomos clínicos'
};
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-24 pb-16 px-4 overflow-hidden" data-id="element-126">
      {/* Glow background effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-red-900/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-127" />

      <div className="max-w-5xl mx-auto text-center z-10" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-6" data-id="element-129">
          <span className="px-4 py-1.5 rounded-full border border-red-900/50 bg-red-950/30 text-red-200 text-sm font-medium tracking-wider uppercase" data-id="element-130">
            {heroContent.eyebrow}
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-serif font-medium leading-tight mb-8 text-brand-light" data-id="element-131">
          {heroContent.headline}
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-4xl mx-auto mb-12" data-id="element-132">
          <div className="rounded-2xl overflow-hidden border border-brand-cardBorder shadow-2xl relative" data-id="element-133">
            <img src={heroContent.imageUrl} alt={heroContent.imageAlt} className="w-full h-full object-contain" data-id="element-134" />
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-xl text-brand-light/80 max-w-3xl mx-auto mb-10 leading-relaxed font-sans" data-id="element-135">
          {heroContent.subheadline}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center gap-4" data-id="element-136">
          <div className="flex items-center gap-1 text-yellow-500" data-id="element-137">
            {[...Array(heroContent.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-138" />)}
          </div>
          <p className="text-sm text-brand-light/60 mb-4" data-id="element-139">
            {heroContent.ratingText}
          </p>

          <a href={heroContent.ctaLink} target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-accent hover:bg-brand-accentHover text-white font-semibold py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-105 shadow-[0_0_30px_rgba(153,27,27,0.4)]" data-id="element-140">
            {heroContent.ctaText}
          </a>
        </motion.div>
      </div>
    </section>;
}